import React, { useEffect, useState } from 'react';
import { Button, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { styleExam } from './styleExam';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import Utils from "../../utils/utils";
import { useStateValue } from '../../context/store';

const defaultValue = {
    firstName: "",
    surname: "",
    regionalId: "",
    orderType: "",
    initDate: "",
    endDate: "",
}

const SearchExam = ({regional, dataMaestras}) => {
    const classes = styleExam();
    const [{}, dispatch] = useStateValue();
    var currentDate = new Date();
    const [minDate, setMinDate] = useState(null);
    const [vFirstName, setVFirstName] = useState(false);
    const [vSurname, setVSurname] = useState(false);
    const [maxInitDate, setMaxInitDate] = useState(
        Utils.getFormattedDateMMddyyyy(currentDate, ".")
    );

    const schema = yup.object().shape({
        firstName: vFirstName ? null : yup.string()
            .notRequired()
            .min(3, "Ingrese mínimo 3 caracteres")
            .max(50, "Ingrese máximo 50 caracteres")
            .matches(
            /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g,
            "Ingrese un nombre válido"
            ),
        surname: vSurname ? null : yup.string()
            .notRequired()
            .min(3, "Ingrese mínimo 3 caracteres")
            .max(50, "Ingrese máximo 50 caracteres")
            .matches(
            /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g,
            "Ingrese un apellido válido"
            ),
        regionalId: yup.string().nullable().notRequired(),
        orderType: yup.string().nullable().notRequired(),
        initDate: yup
            .date()
            .typeError("Formato de fecha inválido")
            .when([], {
              is: (initDate) => initDate && initDate.length > 0,
              then: yup
                .date()
                .typeError("Formato de fecha inválido")
                .nullable(true)
                .notRequired(),
              otherwise: yup
                .date()
                .typeError("Formato de fecha inválido")
                .nullable(true)
                .notRequired(),
            }),
        endDate: yup
            .date()
            .typeError("Formato de fecha inválido")
            .when([], {
              is: (endDate) => endDate && endDate.length > 0,
              then: yup
                .date()
                .typeError("Formato de fecha inválido")
                .nullable(true)
                .notRequired(),
              otherwise: yup
                .date()
                .typeError("Formato de fecha inválido")
                .nullable(true)
                .notRequired(),
            }),
    });

    const {register, handleSubmit, control, formState: {errors}, watch, getValues, setValue } = useForm({
        resolver: yupResolver(schema),
        defaultValue,
        mode: "all",
        reValidateMode: "onChange"
    });

    const onSubmit = (data) => {
        if (
            data.firstName !== null ||
            data.surname !== null ||
            data.orderType !== null ||
            data.regionalId !== null ||
            data.initDate !== null ||
            data.endDate !== null
          ) {
            dispatch({
              type: "SET_FILTER_MEDICAL_EXAM",
              filter: data,
              isFilter: true,
            });
          }
    }

    const clearForm = () => {
        setValue("firstName", "");
        setValue("surname", "");
        setValue("orderType", "");
        setValue("regionalId", "");
        setValue("initDate", null);
        setValue("endDate", null);
        setMaxInitDate( new Date());
        setMinDate(null);
    }

    const clearBtn = () => {
        clearForm();
        dispatch({
          type: "SET_FILTER_MEDICAL_EXAM",
          filter: {
            firstName : null,
            surname: null,
            orderType : null,
            regionalId : null,
            initDate : null,
            endDate : null,
        },
        isFilter: true,
        });
    };

    const onChangeDate = (value) => {
        setMinDate(value);
    };

    const validateMaxInitDate = () => {
        var currentData = getValues();
        if (!currentData.endDate) {
          setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentDate, "."));
        } else {
          setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentData.endDate, "."));
        }
    };

    const updateMaxInitDate = (date) => {
        var currentData = getValues();
        if (!currentData.initDate) {
          setMaxInitDate(date);
        } else {
          setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentDate, "."));
        }
    };

    const valueFirstName = watch("firstName");
    const valueSurname = watch("surname");

    useEffect(() => {
        if(valueFirstName === ""){
            setVFirstName(true);
          }else{
            setVFirstName(false);
          }

          if(valueSurname === ""){
            setVSurname(true);
          }else{
            setVSurname(false);
          }
    }, [valueFirstName, valueSurname])


  return (
    <div className={classes.divSearch}>
        <form onSubmit={handleSubmit(onSubmit)} >
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <FormControl
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={
                        vFirstName ? null : !!errors.hasOwnProperty("firstName") &&
                        errors["firstName"].message
                    }
                    >
                    <Controller
                        name="firstName"
                        control={control}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field }) => (
                        <TextField
                            {...field}
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            name="firstName"
                            label="Primer nombre"
                            variant="outlined"
                            margin="dense"
                            size="small"
                            inputRef={register}
                            fullWidth
                            className={classes.inputForm}
                            error={vFirstName ? null : errors.hasOwnProperty("firstName") && errors["firstName"].message}
                        />
                        )}
                    />
                    <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                        {vFirstName ? null : errors.hasOwnProperty("firstName") && errors["firstName"].message}
                    </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                    <FormControl
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={vSurname ? null : !!errors.hasOwnProperty("surname") &&  errors["surname"].message}
                    >
                    <Controller
                        name="surname"
                        control={control}
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field }) => (
                        <TextField
                            {...field}
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            name="surname"
                            label="Primer apellido"
                            variant="outlined"
                            margin="dense"
                            size="small"
                            inputRef={register}
                            fullWidth
                            className={classes.inputForm}
                            error={vSurname ? null : errors.hasOwnProperty("surname") && errors["surname"].message}
                        />
                        )}
                    />
                    <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                        {vSurname ? null : errors.hasOwnProperty("surname") && errors["surname"].message}
                    </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                    <FormControl
                        variant="outlined"
                        fullWidth
                        size="small"
                        className={classes.formControlGen}
                        error={
                            !!errors.hasOwnProperty("regionalId") &&
                            errors["regionalId"].message
                        }
                        >
                        <InputLabel
                            htmlFor="outlined-select-regionalId"
                            shrink={true}
                        >
                            Regional
                        </InputLabel>
                        <Controller
                            fullWidth
                            control={control}
                            inputRef={register}
                            className = {classes.inputForm}
                            label="Regional"
                            name="regionalId"
                            defaultValue=""
                            size="small"
                            notched={true}
                            inputProps={{
                            name: "regionalId",
                            id: "outlined-select-regionalId",
                            }}
                            as={
                                <Select>
                                    {regional?.map((resp) => (
                                        <MenuItem
                                            key={resp?.id}
                                            value={resp?.id}
                                            className={classes.menuItem}
                                        >
                                            {" "}
                                            {resp?.name}{" "}
                                        </MenuItem>
                                    ))}
                                </Select>
                            }
                        />
                        <FormHelperText>
                            {errors.hasOwnProperty("regionalId") &&
                            errors["regionalId"].message}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                    <FormControl
                        variant="outlined"
                        fullWidth
                        size="small"
                        className={classes.formControlGen}
                        error={
                            !!errors.hasOwnProperty("orderType") &&
                            errors["orderType"].message
                        }
                        >
                        <InputLabel
                            htmlFor="outlined-select-orderType"
                            shrink={true}
                        >
                            Tipo de orden
                        </InputLabel>
                        <Controller
                            fullWidth
                            control={control}
                            inputRef={register}
                            className = {classes.inputForm}
                            label="Tipo de orden"
                            name="orderType"
                            defaultValue=""
                            size="small"
                            notched={true}
                            inputProps={{
                            name: "orderType",
                            id: "outlined-select-orderType",
                            }}
                            as={
                                <Select>
                                    {dataMaestras?.maestras?.tipoOrdenExamenMedico?.map((resp) => (
                                        <MenuItem
                                            key={resp?.clave}
                                            value={resp?.clave}
                                            className={classes.menuItem}
                                        >
                                            {" "}
                                            {resp?.valor}{" "}
                                        </MenuItem>
                                    ))}
                                </Select>
                            }
                        />
                        <FormHelperText>
                            {errors.hasOwnProperty("orderType") &&
                            errors["orderType"].message}
                        </FormHelperText>
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={3} lg={3}>
                    <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                        <Controller
                        as={
                            <KeyboardDatePicker
                            fullWidth
                            inputVariant="outlined"
                            variant="inline"
                            format="dd/MM/yyyy"
                            className = {classes.inputForm}
                            dateFormat="DD/MM/YYYY"
                            label="Desde"
                            InputLabelProps={{ shrink: true }}
                            onAccept={onChangeDate}
                            onOpen={validateMaxInitDate}
                            error={
                                !!errors.hasOwnProperty("initDate") &&
                                errors["initDate"].message
                            }
                            helperText={
                                errors.hasOwnProperty("initDate") &&
                                errors["initDate"].message
                            }
                            minDate="01.01.2020"
                            maxDate={maxInitDate}
                            />
                        }
                        control={control}
                        name="initDate"
                        defaultValue={null}
                        placeholder="Desde"
                        size="small"
                        />
                    </MuiPickersUtilsProvider>
                    <FormHelperText style={{ color: "#f44336" }}>

                    </FormHelperText>
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                    <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                        <Controller
                        as={
                            <KeyboardDatePicker
                            fullWidth
                            inputVariant="outlined"
                            variant="inline"
                            format="dd/MM/yyyy"
                            dateFormat="DD/MM/YYYY"
                            className = {classes.inputForm}
                            label="Hasta"
                            InputLabelProps={{ shrink: true }}
                            onAccept={updateMaxInitDate}
                            error={
                                !!errors.hasOwnProperty("endDate") &&
                                errors["endDate"].message
                            }
                            helperText={
                                errors.hasOwnProperty("endDate") &&
                                errors["endDate"].message
                            }
                            minDate={minDate ? minDate : "01.01.2020"}
                            //maxDate={maxDate}
                            />
                        }
                        control={control}
                        name="endDate"
                        defaultValue={null}
                        placeholder="Hasta"
                        size="small"
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <Button
                        variant="contained"
                        className={classes.buttonSearch}
                        type="submit"
                    >
                        Buscar
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                        variant="contained"
                        className={classes.buttonSearch}
                        onClick={clearBtn}
                    >
                        Limpiar
                    </Button>
                </Grid>
            </Grid>
        </form>
    </div>
  )
}

export default SearchExam;